import React from 'react';
import { Box, Button, Paper, Typography } from '@mui/material';
import { useNavigate } from 'react-router-dom';


export default function About() {
  const navigate = useNavigate();

  return (
    <Box sx={{ maxWidth: 720, mx: 'auto', p: 3 }}>
      <Paper sx={{ p: 4 }}>
        <Typography variant="h4" gutterBottom>À propos de ZoomETF</Typography>
        <Typography paragraph>
          ZoomETF aide les non-spécialistes à formuler un besoin en langage naturel puis à
          comprendre une courte liste d’ETF correspondant aux critères interprétés.
        </Typography>
        <Typography paragraph color="text.secondary">
          Le modèle de langage sert à comprendre la demande lorsqu’il est configuré. Le classement
          et les explications restent déterministes et vérifiables. Les données intégrées sont
          toujours signalées comme données de démonstration.
        </Typography>
        <Typography paragraph color="text.secondary">
          Cet outil est pédagogique et ne remplace pas un conseil financier adapté à votre situation.
        </Typography>
        <Button variant="outlined" onClick={() => navigate('/')}>Retour</Button>
      </Paper>
    </Box>
  );
}
